import { useRef, useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export const useClearSessionOnModuleEntry = (modulePaths: string[]) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const clearedForPath = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname;
    const isModuleEntry = modulePaths.some((modulePath) => currentPath === modulePath);

    if (isModuleEntry && navigationType === 'PUSH' && clearedForPath.current !== currentPath) {
      sessionStorage.removeItem('filterQueryStr');
      clearedForPath.current = currentPath; // mark this path as already cleared
    }
  }, [location.pathname, navigationType, modulePaths]);
};
